export default class {
    Id = null;

    Name = "";

    Color = "#000000";

    mapFromDto(dto) {
        this.Id = dto.Id;
        this.Name = dto.Name;
        this.Color = dto.Color;

        return this;
    }    

}